import { openNotifyModal } from '@src/library/redux/modal/index.ts';

export const openNotReadyModuleNotify = () => {
  return openNotifyModal({
    title: 'Уведомление',
    text: `Данный раздел обновляется. В ближайшее время вы сможете его протестировать`,
    confirmText: 'Понятно',
  });
};
